import { useEffect, useState } from "react";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { quoteOperations } from "@/utils/form-data-manager";

import useSession from "@/utils/use-session";
import { useAuthContext } from "@/context/auth-context";
import { useSession as salesforceSession } from "next-auth/react";
import { useEventContext } from "@/context/events/event-context";
import { Popover, PopoverTrigger, PopoverContent, Button } from "@heroui/react";
import { customerOperations } from "@/utils/form-data-manager";
import CallToAction from "@/components/ui/button/call-to-action";
import { sessionStorageCleanup } from "@/utils/helper";

const MainNavbar = () => {
  const pathname = usePathname();

 useEffect(() => {
  setShowRedirectPopUp(false);
  setShowLogoutPopUp(false);
  setShowDropDown(false);
}, [pathname]);
  const [showDropDown, setShowDropDown] = useState(false);
  const [showLogoutPopUp, setShowLogoutPopUp] = useState(false);

  const [showRedirectPopUp, setShowRedirectPopUp] = useState(false);
  const [redirectTo, setRedirectTo] = useState("");

  const [title, setTitle] = useState("");
  const { logout } = useSession();
  const { setIsLoggedIn } = useAuthContext();

  const router = useRouter();

  const { data: salesforceSessionData } = salesforceSession();
  const { handleSFSignOutEvent } = useEventContext();

  const customerDetails = customerOperations.getLoggedInCustomerDetails();

  const navRouteClass =
    "mx-3 flex flex-col justify-center items-center transform transition-transform duration-200 ease-in-out hover:scale-105";
  const navRouteLinkClass = "flex flex-col justify-center items-center";

  const hideLogoutPopUp = () => {
    setShowLogoutPopUp(false);
  };

  const hideRedirectPopUp = () => {
    setShowRedirectPopUp(false);
  };


const logoutHandler = async () => {
  try {
    setIsLoggedIn(false);
    sessionStorageCleanup(); 
    
    await Promise.all([
      logout(),
      salesforceSessionData ? handleSFSignOutEvent({ callbackUrl: "/customer/account/login" }) : Promise.resolve()
    ]);
    
  } catch (error) {
    console.error("Logout error:", error);
  } 
  finally {
    window.location.replace("/customer/account/login");
  }
};
  
const redirectToHomePage = () => {
  if (quoteOperations.getQuote() && pathname.startsWith('/configurator')) {
    setRedirectTo("homePage");
    setShowRedirectPopUp(true);
  } else {
    sessionStorageCleanup();
    router.push("/");
  }
};

const redirectToMyQuotes = () => {
  if (quoteOperations.getQuote() && pathname.startsWith('/configurator')) {
    setRedirectTo("myQuotes");
    setShowRedirectPopUp(true);
  } else {
    sessionStorageCleanup();
    router.push("/my-quotes");
  }
};

const redirectToConfigurator = () => {
  if (quoteOperations.getQuote() && pathname.startsWith('/configurator')) {
    setRedirectTo("configurator");
    setShowRedirectPopUp(true);
  } else {
    sessionStorageCleanup();
    if (pathname === "/configurator/global-options") {
      window.location.reload();
    } else {
      router.push("/configurator/global-options");
    }
  }
};
  const handleLogOut = () => {
    setShowLogoutPopUp(true);
  };

  const RedirectHandler = () => {
    setShowRedirectPopUp(false);
    if (redirectTo == "homePage") {
      sessionStorageCleanup();
      router.push("/");
    } else if (redirectTo == "myQuotes") {
      sessionStorageCleanup();
      router.push("/my-quotes");
    } else if (redirectTo == "configurator") {
      sessionStorageCleanup();
      if (pathname === "/configurator/global-options") {
        window.location.reload();
      } else {
        router.push("/configurator/global-options");
      }
    }
  };

  useEffect(() => {
    if (pathname === "/configurator/global-options") {
      setTitle("Global Options");
    } else if (pathname === "/configurator/body-options") {
      setTitle("Body Options");
    } else if (pathname.startsWith("/configurator/qm")) {
      setTitle("Quote Management");
    } else if (pathname === "/my-quotes") {
      setTitle("My Quotes");
    } else {
      setTitle("");
    }
  }, [pathname]);

  return (
    <nav className="flex justify-between px-2% shadow-md h-16 items-center relative ">
      <div className="flex justify-center items-center h-14">
        <button className="w-16 h-11 mr-6" onClick={redirectToHomePage}>
          <Image
            src="/assets/duke.png"
            width={100}
            height={100}
            alt="Duke Logo"
            aria-label="logo"
            priority
            className="w-full h-full"
          />
        </button>
        {title && (
          <div className="border-l-2">
            <h1 className="text-lg font-semibold leading-4 text-primary-700 font-myriad px-3 py-3">
              {title}
            </h1>
          </div>
        )}
        <CallToAction
          style="mt-1 text-xs text-gray-700 font-normal w-fit hover:text-primary-600 hover:underline bg-[#0B2841] bg-opacity-50"
          title="Leave Quote Process?"
          subtitle={
            "You are about to exit the active quote process. This will close your session and discard any unsaved data. Do you wish to continue?"
          }
          label={""}
          onConfirm={[RedirectHandler, "btn-secondary", "YES", 1]}
          onCancel={[hideRedirectPopUp, "btn-primary", "NO", 2]}
          isClicked={false}
          popUpOnly={true}
          forceOpen={showRedirectPopUp}
        />
      </div>
      <div className="flex justify-space items-center mt-2 font-medium font-myriad">
        {/* <div className={`${navRouteClass} group`}>
          <button
            className={`${navRouteLinkClass}`}
            onClick={redirectToHomePage}
          >
            <div className="w-4 h-3 relative">
              <svg
                width="16"
                height="12"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-gray-600 group-hover:text-primary-600 "
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.625 0.812871H6.5625C6.7351 0.812871 6.875 0.952773 6.875 1.12537V7.06287C6.875 7.23547 6.7351 7.37537 6.5625 7.37537H0.625C0.452402 7.37537 0.3125 7.23547 0.3125 7.06287V1.12537C0.3125 0.952773 0.452402 0.812871 0.625 0.812871ZM11.6468 0.318086L15.1823 3.85363C15.3043 3.97566 15.3043 4.17352 15.1823 4.29557L11.6467 7.83109C11.5247 7.95313 11.3269 7.95313 11.2048 7.83109L7.66928 4.29555C7.54725 4.17352 7.54725 3.97566 7.66928 3.85361L11.2048 0.318086C11.3269 0.196055 11.5247 0.196055 11.6468 0.318086ZM0.625 8.62537H6.5625C6.7351 8.62537 6.875 8.76527 6.875 8.93787V14.8754C6.875 15.048 6.7351 15.1879 6.5625 15.1879H0.625C0.452402 15.1879 0.3125 15.048 0.3125 14.8754V8.93787C0.3125 8.76527 0.452402 8.62537 0.625 8.62537ZM8.4375 8.62537H14.375C14.5476 8.62537 14.6875 8.76527 14.6875 8.93787V14.8754C14.6875 15.048 14.5476 15.1879 14.375 15.1879H8.4375C8.2649 15.1879 8.125 15.048 8.125 14.8754V8.93787C8.125 8.76527 8.2649 8.62537 8.4375 8.62537Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <p className="mt-1 text-neutral-600 text-xs group-hover:text-primary-600 ">
              Products
            </p>
          </button>
        </div> */}
        <div className={`${navRouteClass} group`}>
          <button
            className={`${navRouteLinkClass}`}
            onClick={redirectToConfigurator}
          >
            <div className="w-4 h-3 relative">
              <svg
                width="16"
                height="13"
                viewBox="0 0 17 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-gray-600 group-hover:text-primary-600"
              >
                <path
                  d="M8.50959 6.62793C7.92561 6.62793 7.37873 6.85449 6.96467 7.26855C6.55256 7.68262 6.32405 8.22949 6.32405 8.81348C6.32405 9.39746 6.55256 9.94434 6.96467 10.3584C7.37873 10.7705 7.92561 10.999 8.50959 10.999C9.09358 10.999 9.64045 10.7705 10.0545 10.3584C10.4666 9.94434 10.6951 9.39746 10.6951 8.81348C10.6951 8.22949 10.4666 7.68262 10.0545 7.26855C9.85227 7.06476 9.61156 6.90318 9.34634 6.79321C9.08113 6.68323 8.7967 6.62705 8.50959 6.62793ZM16.5623 11.2275L15.285 10.1357C15.3455 9.76465 15.3768 9.38574 15.3768 9.00879C15.3768 8.63184 15.3455 8.25098 15.285 7.88184L16.5623 6.79004C16.6588 6.70743 16.7279 6.59741 16.7603 6.47461C16.7928 6.3518 16.7871 6.22202 16.744 6.10254L16.7264 6.05176C16.3749 5.06873 15.8481 4.15753 15.1717 3.3623L15.1365 3.32129C15.0544 3.22471 14.9449 3.15529 14.8226 3.12216C14.7002 3.08904 14.5706 3.09378 14.451 3.13574L12.8651 3.7002C12.2791 3.21973 11.6268 2.84082 10.9197 2.57715L10.6131 0.918945C10.59 0.794028 10.5294 0.679106 10.4394 0.589449C10.3494 0.499791 10.2342 0.439642 10.1092 0.416992L10.0565 0.407227C9.04084 0.223633 7.97053 0.223633 6.9549 0.407227L6.90217 0.416992C6.77716 0.439642 6.66201 0.499791 6.572 0.589449C6.48199 0.679106 6.4214 0.794028 6.39826 0.918945L6.08967 2.58496C5.38933 2.85073 4.73693 3.22872 4.15803 3.7041L2.56037 3.13574C2.44077 3.09344 2.31114 3.08854 2.18868 3.12168C2.06623 3.15482 1.95676 3.22444 1.87483 3.32129L1.83967 3.3623C1.16446 4.15838 0.637856 5.06935 0.284983 6.05176L0.267404 6.10254C0.179514 6.34668 0.25178 6.62012 0.449045 6.79004L1.74201 7.89355C1.68147 8.26074 1.65217 8.63574 1.65217 9.00684C1.65217 9.38184 1.68147 9.75684 1.74201 10.1201L0.452951 11.2236C0.356459 11.3062 0.287397 11.4163 0.254951 11.5391C0.222505 11.6619 0.228211 11.7916 0.271311 11.9111L0.288889 11.9619C0.642404 12.9443 1.16389 13.8525 1.84358 14.6514L1.87873 14.6924C1.96087 14.789 2.07034 14.8584 2.19272 14.8915C2.3151 14.9246 2.44464 14.9199 2.56428 14.8779L4.16194 14.3096C4.74397 14.7881 5.3924 15.167 6.09358 15.4287L6.40217 17.0947C6.42531 17.2196 6.4859 17.3346 6.57591 17.4242C6.66591 17.5139 6.78107 17.574 6.90608 17.5967L6.95881 17.6064C7.98443 17.791 9.03476 17.791 10.0604 17.6064L10.1131 17.5967C10.2381 17.574 10.3533 17.5139 10.4433 17.4242C10.5333 17.3346 10.5939 17.2196 10.617 17.0947L10.9237 15.4365C11.6307 15.1709 12.283 14.7939 12.869 14.3135L14.4549 14.8779C14.5745 14.9202 14.7041 14.9251 14.8266 14.892C14.949 14.8589 15.0585 14.7892 15.1405 14.6924L15.1756 14.6514C15.8553 13.8486 16.3768 12.9443 16.7303 11.9619L16.7479 11.9111C16.8319 11.6689 16.7596 11.3975 16.5623 11.2275ZM8.50959 12.2471C6.61311 12.2471 5.076 10.71 5.076 8.81348C5.076 6.91699 6.61311 5.37988 8.50959 5.37988C10.4061 5.37988 11.9432 6.91699 11.9432 8.81348C11.9432 10.71 10.4061 12.2471 8.50959 12.2471Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <p className="mt-1 text-neutral-600 text-xs group-hover:text-primary-600 ">
              Configurator
            </p>
          </button>
        </div>
        
        {/* <div className={`${navRouteClass} group`}>
          <button
            className={`${navRouteLinkClass}`}
            onClick={redirectToHomePage}
          >
            <div className="w-4 h-3 relative">
              <svg
                width="16"
                height="12"
                viewBox="0 0 18 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-gray-600 group-hover:text-primary-600 "
              >
                <path
                  d="M17.75 5.34375C17.75 10.8125 9.64141 15.2391 9.29609 15.4219C9.20508 15.4708 9.10335 15.4965 9 15.4965C8.89665 15.4965 8.79492 15.4708 8.70391 15.4219C8.35859 15.2391 0.25 10.8125 0.25 5.34375C0.251447 4.05955 0.762235 2.82837 1.6703 1.9203C2.57837 1.01223 3.80955 0.501447 5.09375 0.5C6.70703 0.5 8.11953 1.19375 9 2.36641C9.88047 1.19375 11.293 0.5 12.9062 0.5C14.1904 0.501447 15.4216 1.01223 16.3297 1.9203C17.2378 2.82837 17.7486 4.05955 17.75 5.34375Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <p className="mt-1 text-neutral-600 text-xs group-hover:text-primary-600 ">
              Favorites
            </p>
          </button>
        </div> */}
        <div className={`${navRouteClass} group`}>
          <button
            className={`${navRouteLinkClass}`}
            onClick={redirectToMyQuotes}
          >
            <div className="w-4 h-3 relative " data-cy="my-quotes">
              <svg
                width="16"
                height="12"
                viewBox="0 0 17 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-gray-600 group-hover:text-primary-600"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.00065 11.5013L2.00065 1.5013C2.00065 1.28029 2.08845 1.06833 2.24473 0.912047C2.40101 0.755766 2.61297 0.667969 2.83398 0.667969L16.1673 0.667972C16.3883 0.667972 16.6003 0.755769 16.7566 0.912049C16.9129 1.06833 17.0007 1.28029 17.0007 1.5013L17.0006 14.8346C17.0006 15.4977 16.7373 16.1336 16.2684 16.6024C15.7996 17.0712 15.1637 17.3346 14.5006 17.3346L2.83398 17.3346C2.17094 17.3346 1.53506 17.0712 1.06621 16.6024C0.597374 16.1336 0.333982 15.4977 0.333982 14.8346L0.333982 13.168L13.6673 13.168L13.6673 14.8346C13.6673 15.0557 13.7551 15.2676 13.9114 15.4239C14.0677 15.5802 14.2796 15.668 14.5006 15.668C14.7217 15.668 14.9336 15.5802 15.0899 15.4239C15.2462 15.2676 15.334 15.0557 15.334 14.8346L15.334 11.5013L2.00065 11.5013ZM3.5 3.00391L15.5 3.00391L15.5 4.60391L3.5 4.60391L3.5 3.00391ZM15.5 6.60547L3.5 6.60547L3.5 8.20547L15.5 8.20547L15.5 6.60547Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <p className="mt-1 text-neutral-600 text-xs group-hover:text-primary-600 ">
              My Quotes
            </p>
          </button>
        </div>
        <Popover showArrow offset={10} placement="bottom-end" onOpenChange={setShowDropDown}>
          <PopoverTrigger>
            <button
              className={`${navRouteLinkClass} relative mx-3 z-0`}
            >
              <div className="flex flex-col justify-center items-center group">
                <div className=" w-4 h-3 relative right-1">
                  <svg
                    width="16"
                    height="12"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-gray-600 group-hover:text-primary-600"
                  >
                    <path
                      d="M9.5 0C10.7598 0 11.968 0.500445 12.8588 1.39124C13.7496 2.28204 14.25 3.49022 14.25 4.75C14.25 6.00978 13.7496 7.21796 12.8588 8.10876C11.968 8.99956 10.7598 9.5 9.5 9.5C8.24022 9.5 7.03204 8.99956 6.14124 8.10876C5.25044 7.21796 4.75 6.00978 4.75 4.75C4.75 3.49022 5.25044 2.28204 6.14124 1.39124C7.03204 0.500445 8.24022 0 9.5 0ZM9.5 11.875C14.7487 11.875 19 14.0006 19 16.625V19H0V16.625C0 14.0006 4.25125 11.875 9.5 11.875Z"
                      fill="currentColor"
                      className=""
                      id="path"
                    />
                  </svg>
                </div>
                <div className="flex">
                  <p className="mt-1 text-neutral-600 text-xs group-hover:text-primary-600 ">
                    Account
                  </p>
                  {showDropDown && (
                    <MdKeyboardArrowUp className="relative top-1 text-neutral-600 group-hover:text-primary-600" />
                  )}
                  {!showDropDown && (
                    <MdKeyboardArrowDown className="relative top-1 text-neutral-600 group-hover:text-primary-600" />
                  )}
                </div>
              </div>
            </button>
          </PopoverTrigger>

          <PopoverContent className="rounded-md shadow-2xl border border-gray-200 bg-white">
            <div className="w-28 my-2">
              <div className="flex items-center justify-center">
                <div className="h-full border-b border-gray-300 flex items-end w-full pb-1 overflow-wrap: break-word text-start">
                  <h1 className="text-xs leading-3 text-gray-700 font-semibold font-myriad capitalize">
                    Hello {customerDetails?.firstName}!
                  </h1>
                </div>
              </div>

              <div className="flex flex-col text-xs leading-3 mt-3 text-gray-700 text-left">
                {/* <button className="text-left hover:text-primary-600 hover:underline w-fit">
                  Profile
                </button> */}
                <button
                  className="text-left hover:text-primary-600 hover:underline w-fit"
                  onClick={handleLogOut}
                >
                  Logout
                </button>
              </div>
            </div>
          </PopoverContent>
        </Popover>
        <CallToAction
          style="mt-1 text-xs text-gray-700 font-normal w-fit hover:text-primary-600 hover:underline"
          title="Do you want to logout?"
          subtitle={""}
          label={"Logout"}
          onConfirm={[logoutHandler, "btn-primary", "YES", 1]}
          onCancel={[hideLogoutPopUp, "btn-secondary", "NO", 2]}
          isClicked={false}
          popUpOnly={true}
          forceOpen={showLogoutPopUp}
        />
      </div>
    </nav>
  );
};

export default MainNavbar;
